import exclusiveInterfaces from './interface';

// for development use
const useDummyInterfaces = false;

const interfaces = useDummyInterfaces
  ? require('mocks/agenlite/exclusive').default
  : window.API.wrap(exclusiveInterfaces, 'xhrAgenlitePublic');

export default interfaces;
